import React, {useEffect, useState} from 'react';
import {Box, Grid, Link, Typography} from "@mui/material";
import styles from "../../../../../flyerDetailsPopup/flyerDetailsPopup.module.scss";
import RadioButton from "../../../../../../../com/radioButton/RadioButton";
import PhoneInput from 'react-phone-number-input'
import {TextareaWithLabel} from "../../../../../../../com/textareaWithLabel/textareaWithLabel";
import {
    CheckoutUrlSettingStateDto,
    ConversionDto,
    ExampleCodeAndQtyDto,
} from "../../../../../../../dtos";
import _ from "lodash";
import {createExampleCheckoutUrl, createExampleCheckoutUrlApp} from "../../../../../../../globals/globalFunctions";

interface Props {
    conversionUrlSettingState: CheckoutUrlSettingStateDto;
    handleChange: (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => void;
    checkValidValue: (inputName: string) => boolean;
    onChangePhoneNumber: (phoneNumber: string) => void;
    handleChangeRadioBtn: (value: string) => void;
}

const AccountCheckoutSettingForPopup: React.FC<Props> = ({
                                                             conversionUrlSettingState,
                                                             handleChange,
                                                             checkValidValue,
                                                             onChangePhoneNumber,
                                                             handleChangeRadioBtn
                                                         }) => {
    const [checkoutUrl, setCheckoutUrl] = useState<string>("");
    const [checkoutUrlApp, setCheckoutUrlApp] = useState<string>("");

    useEffect(() => {
        let checkoutUrlLink: string = conversationUrlResult(conversionUrlSettingState);
        setCheckoutUrl(checkoutUrlLink);
        let checkoutUrlLinkApp: string = conversationUrlResultApp(conversionUrlSettingState);
        setCheckoutUrlApp(checkoutUrlLinkApp);

        return () => {
            setCheckoutUrl("");
            setCheckoutUrlApp("")
        };
    }, [conversionUrlSettingState]);

    const conversationUrlResult = (conversionUrlSettingState: CheckoutUrlSettingStateDto): string => {
        let checkoutUrlLink: string = ``;
        // if (state.isSelectAccountCheckoutUrl && conversionUrlSetting.data) {
        //     checkoutUrlLink = createExampleCheckoutUrl(conversionUrlSetting.data, firstExample, secondExample);
        // } else {
        if (!_.isEmpty(conversionUrlSettingState)) {
            const firstExample: ExampleCodeAndQtyDto = {
                code: conversionUrlSettingState.exampleItemCode1 || "",
                qty: conversionUrlSettingState.exampleItemQTY1 || ""
            }
            const secondExample: ExampleCodeAndQtyDto = {
                code: conversionUrlSettingState.exampleItemCode2 || "",
                qty: conversionUrlSettingState.exampleItemQTY2 || ""
            }
            const conversionSetting: ConversionDto = {...conversionUrlSettingState};
            checkoutUrlLink = createExampleCheckoutUrl(conversionSetting, firstExample, secondExample);
        }
        // }
        return checkoutUrlLink;
    }

    const conversationUrlResultApp = (conversionUrlSettingState: CheckoutUrlSettingStateDto): string => {
        let checkoutUrlLinkApp: string = ``;
        // if (state.isSelectAccountCheckoutUrl && conversionUrlSetting.data?.conversionUrlBaseApp) {
        //     checkoutUrlLinkApp = createExampleCheckoutUrlApp(conversionUrlSetting.data, firstExample, secondExample);
        // } else {
        if (!_.isEmpty(conversionUrlSettingState)) {
            const firstExample: ExampleCodeAndQtyDto = {
                code: conversionUrlSettingState.exampleItemCode1 || "",
                qty: conversionUrlSettingState.exampleItemQTY1 || ""
            }
            const secondExample: ExampleCodeAndQtyDto = {
                code: conversionUrlSettingState.exampleItemCode2 || "",
                qty: conversionUrlSettingState.exampleItemQTY2 || ""
            }
            const conversionSetting: ConversionDto = {...conversionUrlSettingState};
            checkoutUrlLinkApp = createExampleCheckoutUrlApp(conversionSetting, firstExample, secondExample);
        }
        // }
        return checkoutUrlLinkApp;
    }

    const onChangeCheckoutBtnText = () => {

    }

    return (
        <Box sx={{flex: `1 1 auto`, overflow: "auto", padding: "10px 20px"}}>
            <Grid container alignItems={`center`} justifyContent={`flex-end`}>
                <Grid item xs>
                    <Typography fontWeight={700} lineHeight={1}>
                        My List Checkout*:
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    <Grid container>
                        <Grid item xs>
                            <RadioButton
                                label="Email to:"
                                name="fulfilment_list_option"
                                value={"0"}
                                checked={conversionUrlSettingState.conversionType === 0}
                                onChange={handleChangeRadioBtn}
                            />
                        </Grid>
                        <Grid item xs={7}>
                            <Box sx={{display: `flex`, alignItems: `center`, width: `100%`}}>
                                <TextareaWithLabel
                                    fieldName={"conversionEmail"}
                                    labelGridSizeNumber={4}
                                    valueForInput={conversionUrlSettingState.conversionEmail}
                                    isBold={true}
                                    maxLength={100}
                                    onChangeInput={handleChange}
                                    isNotValid={!checkValidValue('conversionEmail')}
                                    isRequired={conversionUrlSettingState.conversionType === 0}
                                    labelAlign={"end"}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container alignItems={`center`} justifyContent={`flex-end`}
                  sx={{mb: `20px`}}>
                <Grid item xs={8}>
                    <Grid container my={`10px`}>
                        <Grid item xs>
                            <RadioButton
                                label="Checkout URL:"
                                name="fulfilment_list_option"
                                value={"1"}
                                checked={conversionUrlSettingState.conversionType === 1}
                                onChange={handleChangeRadioBtn}
                            />
                        </Grid>
                    </Grid>
                    <Box
                        sx={{
                            display: "flex",
                            flexFlow: "column",
                            rowGap: "16px",
                            paddingLeft: "25px"
                        }}
                    >
                        <Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexFlow: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                <Typography fontSize={"14px"} color={"#808080"}>
                                    Target Web/PC:
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    display: `flex`,
                                    alignItems: `center`,
                                }}
                            >
                                {
                                    checkoutUrl &&
                                    <Link href={checkoutUrl} underline="always" rel="noreferrer"
                                          target="_blank"
                                          sx={{wordBreak: `break-all`}}>
                                        {checkoutUrl}
                                    </Link>
                                }
                                {
                                    !checkoutUrl &&
                                    <Typography color={"#808080"}>
                                        Not selected
                                    </Typography>
                                }
                            </Box>
                        </Box>
                        <Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexFlow: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                <Typography fontSize={"14px"} color={"#808080"}>
                                    Target App/Mobile:
                                </Typography>
                            </Box>
                            <Box sx={{
                                display: `flex`,
                            }}>
                                {checkoutUrlApp && conversionUrlSettingState.isShowAppSetting &&
                                    <Link href={checkoutUrlApp} underline="always" rel="noreferrer"
                                          target="_blank"
                                          sx={{wordBreak: `break-all`}}>
                                        {checkoutUrlApp}
                                    </Link>
                                }

                                {
                                    (!checkoutUrlApp || !conversionUrlSettingState.isShowAppSetting) &&
                                    <Typography color={"#808080"}>
                                        Not selected
                                    </Typography>
                                }
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Grid container alignItems={`center`} justifyContent={`flex-end`}>
                <Grid item xs={8}>
                    <Grid container mt={`10px`} mb={"4px"}>
                        <Grid item xs>
                            <RadioButton
                                label="WhatsApp:"
                                name="fulfilment_list_option"
                                value={"3"}
                                checked={conversionUrlSettingState.conversionType === 3}
                                onChange={handleChangeRadioBtn}
                            />
                        </Grid>
                        <Grid item xs={7}>
                            <Box sx={{display: `flex`, alignItems: `center`, width: `100%`}}>
                                <PhoneInput
                                    style={{
                                        width: `100%`,
                                    }}
                                    name={"conversionPhoneNo"}
                                    className={`${styles.phoneInput} ${conversionUrlSettingState.conversionType === 3 && styles.requiredField}  ${!checkValidValue('conversionPhoneNo') ? styles.error_signal : ''}`}
                                    placeholder="Enter phone number"
                                    value={conversionUrlSettingState.conversionPhoneNo}
                                    onChange={onChangePhoneNumber}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container alignItems={`center`} justifyContent={`flex-end`}
                  sx={{mb: `20px`}}>
                <Grid item xs={8}>
                    <Grid container my={`4px`} justifyContent={`flex-end`}>
                        <Grid item xs={7}>
                            <Box sx={{display: `flex`, flexFlow: "column", width: `100%`, rowGap: "5px"}}>
                                <TextareaWithLabel
                                    labelGridSizeNumber={12}
                                    fieldName={"conversionPhoneMessage"}
                                    valueForInput={conversionUrlSettingState.conversionPhoneMessage}
                                    labelCaption={'WhatsApp Message:'}
                                    maxLength={100}
                                    onChangeInput={handleChange}
                                    isNotValid={!checkValidValue('conversionPhoneMessage')}
                                    isRequired={conversionUrlSettingState.conversionType === 3}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {/*<Box>*/}
            {/*    /!*rows*!/*/}
            {/*    <Grid container alignItems={`center`}>*/}
            {/*        <TextareaWithLabel*/}
            {/*            labelGridSizeNumber={4}*/}
            {/*            valueForInput={""}*/}
            {/*            onChangeInput={onChangeCheckoutBtnText}*/}
            {/*            labelCaption={`Checkout Button Text:`}*/}
            {/*            isBold={true}*/}
            {/*            fieldName={`checkoutBtn`}*/}
            {/*            maxLength={30}*/}
            {/*            isRequired={true}*/}
            {/*            isNotValid={true}*/}
            {/*        />*/}
            {/*    </Grid>*/}
            {/*</Box>*/}
        </Box>

    )
}

export default AccountCheckoutSettingForPopup;